import { useState, useEffect } from 'react';
import axios from 'axios';
import { AntesDespues } from '@/components/AntesDespues';

const API = process.env.REACT_APP_BACKEND_URL;
const AZUL = '#1F8FE0';
const NAVY = '#0E2A47';

const LINEAS = {
  pasamanos_acero_inox: 'Pasamanos',
  ventanas_puertas_euro: 'Ventanas Euro',
  fachadas_vidrio_templado: 'Fachadas',
  duchas_mamparas: 'Duchas',
  techo_curvo: 'Techo Curvo',
};

export const GaleriaProyectos = () => {
  const [items, setItems] = useState([]);
  const [filtro, setFiltro] = useState('todos');
  const [limite, setLimite] = useState(8);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    Promise.all(
      Object.keys(LINEAS).map((k) =>
        axios.get(`${API}/api/landing/carrusel/${k}`)
          .then((r) => (r.data.items || []).filter((it) => it.tipo !== 'video').map((it) => ({ ...it, producto: k })))
          .catch(() => [])
      )
    ).then((res) => {
      const all = res.flat();
      const mezcla = [];
      const copia = res.map((arr) => [...arr]);
      while (mezcla.length < all.length) {
        copia.forEach((arr) => { if (arr.length) mezcla.push(arr.shift()); });
      }
      setItems(mezcla);
    });
  }, []);

  const visibles = items.filter((it) => filtro === 'todos' || it.producto === filtro);

  return (
    <section id="galeria" style={{ background: '#F1F6FB' }}>
      <div className="max-w-6xl mx-auto px-4 py-16">
        <p style={{ color: AZUL }} className="font-black text-xs tracking-[0.25em] uppercase mb-2 text-center">Trabajos reales</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-2" style={{ color: NAVY }}>
          Galería de <span style={{ color: AZUL }}>proyectos</span>
        </h2>
        <p className="text-slate-500 text-sm text-center mb-7">Proyectos instalados por nuestro equipo en Guatemala y El Salvador.</p>

        <div className="flex gap-2 overflow-x-auto pb-2 justify-start sm:justify-center mb-6" data-testid="galeria-filtros">
          {[['todos', 'Todos'], ...Object.entries(LINEAS)].map(([k, label]) => (
            <button key={k} onClick={() => { setFiltro(k); setLimite(8); }} data-testid={`galeria-filtro-${k}`}
              className={`shrink-0 text-xs font-black px-4 py-2 rounded-md border transition-colors ${filtro === k ? 'text-white border-transparent shadow-md' : 'bg-white border-slate-200 text-slate-500 hover:text-slate-800 hover:border-slate-400'}`}
              style={filtro === k ? { background: AZUL } : {}}>
              {label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="galeria-grid">
          {visibles.slice(0, limite).map((it) => (
            <button key={`${it.producto}-${it.id}`} onClick={() => setLightbox(it)}
              className="relative group rounded-xl overflow-hidden border border-slate-200 bg-white shadow-sm text-left focus:outline-none">
              <img src={it.url} alt={it.caption || LINEAS[it.producto]} loading="lazy"
                className="w-full h-40 sm:h-52 object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end">
                <div className="p-3">
                  <p className="text-white text-xs font-black leading-snug">{it.caption || 'Proyecto instalado'}</p>
                </div>
              </div>
              <span style={{ background: AZUL }} className="absolute top-2 left-2 text-white text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wide shadow">
                {LINEAS[it.producto]}
              </span>
            </button>
          ))}
        </div>

        {visibles.length > limite && (
          <div className="text-center mt-6">
            <button onClick={() => setLimite((l) => l + 8)} data-testid="galeria-ver-mas"
              className="border font-black px-6 py-2.5 rounded-md text-sm transition-colors hover:text-white"
              style={{ color: AZUL, borderColor: AZUL }}
              onMouseEnter={(e) => { e.currentTarget.style.background = AZUL; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}>
              VER MÁS PROYECTOS
            </button>
          </div>
        )}

        <AntesDespues />
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-testid="galeria-lightbox">
          <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.url} alt={lightbox.caption} className="w-full max-h-[75vh] object-contain rounded-xl" />
            <div className="flex items-center justify-between gap-3 mt-3">
              <div>
                <p className="text-white font-black text-sm">{lightbox.caption || 'Proyecto instalado'}</p>
                <p style={{ color: '#5BC0FF' }} className="text-xs font-bold">{LINEAS[lightbox.producto]}</p>
              </div>
              <button onClick={() => setLightbox(null)} data-testid="galeria-lightbox-cerrar"
                className="bg-white/10 hover:bg-white/25 text-white font-black text-xs px-4 py-2 rounded-md transition-colors shrink-0">
                CERRAR ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
